module.exports = __webpack_public_path__ + "img/toAudit.ade991a3.png";